// FEATURES
import { LOCAL_STORAGE_PERMISSIONS } from '../../consts/common'

const permissionsInLocalStorage = JSON.parse(
  localStorage.getItem(LOCAL_STORAGE_PERMISSIONS)
)

const hasPermissionForTabs = tabName => {
  console.log(tabName)
  if (permissionsInLocalStorage && permissionsInLocalStorage.features) {
    // const superAdminPermission = permissionsInLocalStorage.crud.includes(
    //   'Super Admin'.toLowerCase()
    // )
    const superAdminPermission = Boolean(window.localStorage.getItem('isGod'))

    const selectedTabPermission = permissionsInLocalStorage.features[tabName]
    return Boolean(
      superAdminPermission ||
        (selectedTabPermission && window.localStorage.allowed === 'true')
    )
  }
  return false
}

export const isAllowedToViewLocationTab = () => {
  return hasPermissionForTabs('location')
}

export const isAllowedToViewServicesTab = () => {
  return hasPermissionForTabs('service')
}

export const isAllowedToViewPeopleTab = () => {
  return hasPermissionForTabs('people')
}

export const isAllowedToViewAccountTab = () => {
  return hasPermissionForTabs('account')
}

const hasPermissionForFeature = featureName => {
  if (permissionsInLocalStorage && permissionsInLocalStorage.crud) {
    // const superAdminPermission = permissionsInLocalStorage.crud.includes(
    //   'Super Admin'.toLowerCase()
    // )
    // temporarily allow this for testing, waiting for API to get fixed
    const superAdminPermission = Boolean(window.localStorage.getItem('isGod'))

    const selectedFeaturePermission = permissionsInLocalStorage.crud.includes(
      featureName.toLowerCase()
    )
    return superAdminPermission || selectedFeaturePermission
  }
  return false
}

export const isAllowedToUpdateFeatureGroupAssignment = () => {
  const FEATURE_NAME = 'Update Feature-Group assignment'
  return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToUpdateGroupInformation = () => {
  const FEATURE_NAME = 'Update Group Information'
  return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToCreateNewGroup = () => {
  const FEATURE_NAME = 'Create New Group'
  return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToUpdateUserGroupAssignment = () => {
  const FEATURE_NAME = 'Update user-group assignment'
  return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToUpdateResourceInformation = () => {
  const FEATURE_NAME = 'Update Resource Information'
  return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToManageData = () => {
  const FEATURE_NAME = 'Data Management'
  return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToViewFeatureSetInformation = () => {
  const FEATURE_NAME = 'View Feature set information'
  return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToViewGroupInformation = () => {
  const FEATURE_NAME = 'View Group information'
  return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToViewUserInformation = () => {
  const FEATURE_NAME = 'View User information'
  return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToViewResourceInformation = () => {
  const FEATURE_NAME = 'View Resource Set Information'
  return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToViewAdminAccess = () => {
  return true
  // temp fix until the backend fixes the permission
  // const FEATURE_NAME = 'View Admin access'
  // return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToViewDashboardAndWidgetInfo = () => {
  const FEATURE_NAME = 'View Dashboard tab'
  return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToViewDashboardDataTab = () => {
  const FEATURE_NAME = 'View dashboard data tab'
  return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToCreateDashboardData = () => {
  const FEATURE_NAME = 'Create dashboard data'
  return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToUpdateDashboardData = () => {
  const FEATURE_NAME = 'Update dashboard data'
  return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToDeleteDashboardData = () => {
  const FEATURE_NAME = 'Delete dashboard data'
  return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToOverrideChanges = () => {
  const FEATURE_NAME = 'Override changes'
  return hasPermissionForFeature(FEATURE_NAME)
}

export const isAllowedToAccessToAdminDashboard = () => {
  return Boolean(window.localStorage.getItem('isGod'))
  // const viewGroupInformationPermission = isAllowedToViewGroupInformation()
  // const viewFeatureSetInformationPermission = isAllowedToViewFeatureSetInformation()
  // const viewResourceInformationPermission = isAllowedToViewResourceInformation()
  // const viewUserInformationPermission = isAllowedToViewUserInformation()
  // const createSmartFormPermission = isAllowedToManageData()
  // const viewAdminAccessPermission = isAllowedToViewAdminAccess()

  // return viewGroupInformationPermission||viewFeatureSetInformationPermission||viewResourceInformationPermission||
  //     viewUserInformationPermission||createSmartFormPermission||viewAdminAccessPermission
}

export const checkQuickViewPermission = (
  setAllowed,
  permissions
) => {
  let canView = false
  permissions.forEach((permission) => {
    if(permission.split('.')[1] === 'view')
    {
      canView = true
    }
  })
  setAllowed(canView)
  window.localStorage.setItem('allowed', canView)
}
